import axios from "axios";
import { message } from "antd";
import { CompanyID, CloudFrontUrl, AwsUploadFiles } from "configs/AppConfig";
import axiosInstance from "auth/axiosInstance";
const shortUUID = require("short-uuid");

let AwsService = {};
const awsAxiosInstance = axios.create();

const getUploadURL = async (data) => {
  try {
    const response = await axiosInstance({
      method: "post",
      url: `${AwsUploadFiles}`,
      data: {
        object_key: data,
      },
    });
    return response.data.upload_url;
  } catch (error) {
    message.error(error.message || "Failed to upload file");
    throw error;
  }
};

AwsService.uploadFile = async function (file, fileType, uploadPercentageFile) {
  const extension = file.name.split(".").pop();
  const fileName = shortUUID.generate() + "." + extension;
  const contentType = fileType + "/" + extension;

  const formData = new FormData();
  formData.append("file", file, fileName);
  const objectKey = `${CompanyID}/${fileType}/${fileName}`;
  const uploadURL = await getUploadURL(objectKey);
  const url = `${CloudFrontUrl}/${CompanyID}/${fileType}/${fileName}`;

  try {
    var options = {
      headers: {
        "Content-Type": file.type,
      },
      onUploadProgress(progress) {
        const { loaded, total } = progress;
        let precentage = Math.floor((loaded * 100) / total);
        uploadPercentageFile(precentage);
      },
    };
    const response = await awsAxiosInstance.put(uploadURL, file, options);

    return { url, response };
  } catch (error) {
    message.error(error.message || "Failed to upload file");
    throw error;
  }
};

AwsService.postVideo = async function (videoFile, uploadPercentageFile) {
  return AwsService.uploadFile(videoFile, "video", uploadPercentageFile);
};

AwsService.postDocument = async function (documentFile, uploadPercentageFile) {
  return AwsService.uploadFile(documentFile, "document", uploadPercentageFile);
};

AwsService.postImage = async function (imageFile, uploadPercentageFile) {
  return AwsService.uploadFile(imageFile, "image", uploadPercentageFile);
};

AwsService.postAudio = async function (audioFile, uploadPercentageFile) {
  return AwsService.uploadFile(audioFile, "audio", uploadPercentageFile);
};

export default AwsService;
